const separatorSchema = {
  blockSlug: "grigora/separator",
  selector: "hr",
  schema: {
    hr: {},
  },
  transform: (node) => {
    return {
      blockSlug: "grigora/separator",
    };
  },
};

export { separatorSchema };
